import * as ShadTooltip from '../../core/components/tooltip'

export function TooltipProvider(props: React.ComponentProps<typeof ShadTooltip.TooltipProvider>) {
  return <ShadTooltip.TooltipProvider {...props} />
}

export function Tooltip(props: React.ComponentProps<typeof ShadTooltip.Tooltip>) {
  return <ShadTooltip.Tooltip {...props} />
}

export function TooltipTrigger(props: React.ComponentProps<typeof ShadTooltip.TooltipTrigger>) {
  return <ShadTooltip.TooltipTrigger {...props} />
}

export function TooltipContent(props: React.ComponentProps<typeof ShadTooltip.TooltipContent>) {
  return <ShadTooltip.TooltipContent {...props} />
}
